// extracted by mini-css-extract-plugin
module.exports = {"wtblogocont":"Where2Buy-module--wtblogocont--39nvh"};